import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {connect} from 'react-redux';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import commonActionCreators from '../shared/store/common/action-creators';
import NoMatch from '../shared/components/NoMatch';
import ActiveFtos from './components/active-ftos/ActiveFtos';
import AuthenticatedRoute from '../shared/components/AuthenticatedRoute';
import NavDrawer from './components/common/nav-drawer/NavDrawer';
import NotificationsContainer from './components/notifications-container/NotificationsContainer';
import Forbidden from '../shared/components/Forbidden';
import AddReportContainer from './components/add-report/AddReportContainer';
import DashboardContainer from './components/dashboard/DashboardContainer';
import DepartmentSettings from './components/department-settings/DepartmentSettings';
import FormContainer from './components/forms/FormContainer';
import MyDepartmentDetail from './components/my-department/MyDepartmentDetail';
import MyOitContainer from './components/oits/MyOitContainer';
import MyProfileContainer from './components/my-profile/MyProfileContainer';
import MyCompletedReports from './components/my-training-program/MyCompletedReports';
import MyTrainingProgramDetail from './components/my-training-program/MyTrainingProgramDetail';
import OitContainer from './components/oits/OitContainer';
import ReportContainer from './components/reports/ReportContainer';
import TagsIndex from './components/tags/TagsIndex';
import TaskGroupContainer from './components/task-groups/TaskGroupContainer';
import TrainingProgramContainer from './components/training-program/TrainingProgramContainer';
import UserContainer from './components/users/UserContainer';
import PrintForms from './components/forms/PrintForms';
import ScheduleReportsCalendar from './components/reports/ScheduleReportsCalendar';
import TaskTraining from "./components/tasks-training/TaskTraining";
import {initApp} from "./services/app-init";
import SubDepartments from "./components/sub-departments/SubDepartments";
import OitAnalytics from "./components/analytics/OitAnalytics";
import DepartmentUploads from "./components/uploads/DepartmentUploads";
import PackagerPage from "./components/packager/PackagerPage";
import TestTemplatesIndex from "./components/test-templates/TestTemplatesIndex";
import TestTemplateReportsIndex from "./components/test-templates/TestTemplateReportsIndex";
import ScheduleTestsCalendar from "./components/reports/ScheduleTestsCalendar";
import TestsIndex from "./components/tests/TestsIndex";
import PersonalScheduleIndex from "./components/calendar/PersonalScheduleIndex";
import FtoCalendarPage from './components/calendar/FtoCalendarPage';
import FtoAnalytics from "./components/analytics/FtoAnalytics";
import { Auth } from "../shared/services/aws";
import { clearSharedStorage } from "../shared/services/shared-storage";

class SubscriberApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiError: null,
      isErrorModalOpen: false,
    };
    this.closeErrorModal = this.closeErrorModal.bind(this);

    initApp()
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    // document.body.classList.add('dark-mode')
  }

  componentDidUpdate() {
    if (!!this.props.apiErrors && !this.state.isErrorModalOpen) {
      this.openErrorModal(this.props.apiErrors[0]);
      this.props.clearApiError();
    }
  }

  // ----------------------
  // Computed
  // ----------------------

  get apiErrorData() {
    console.log(this.state.apiError);
    return this.state.apiError && this.state.apiError.data ? JSON.stringify(this.state.apiError.data) : '';
  }

  get apiErrorMessage() {
    return this.state.apiError ? this.state.apiError.message : '';
  }

  get apiErrorType() {
    return this.state.apiError ? this.state.apiError.type : '';
  }

  // ----------------------
  // Methods
  // ----------------------

  closeErrorModal() {
    if(this.state.apiError.code === 423){
      this.handleLogout()
    }
    this.setState({ isErrorModalOpen: false });
  }

  openErrorModal(apiError) {
    this.setState({
      apiError,
      isErrorModalOpen: true,
    });
  }

  handleLogout() {
    Auth.signOut();
    clearSharedStorage()
      .then(() => {
        window.location.href = 'https://departmentware.com';
      })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Router>
        <div className="app-layout">
          <NavDrawer />
          <NotificationsContainer />
          <div className="app-content-container">
            <Switch>
              {/* Dashboard */}

              <AuthenticatedRoute
                component={AddReportContainer}
                path="/add-report"
              />
              {/* Dashboard */}

              <AuthenticatedRoute
                component={DashboardContainer}
                path="/dashboard"
              />

              {/*
                Department Profile
              */}

              <AuthenticatedRoute
                component={MyDepartmentDetail}
                path="/my-department"
              />

              {/*
                Department Settings
              */}

              <AuthenticatedRoute
                allow={['depadmin']}
                component={DepartmentSettings}
                path="/department-settings"
              />

              {/*
                Department Uploads
              */}

              <AuthenticatedRoute
                allow={['depadmin', 'ftoc', 'sup', 'cstaff', 'chief', 'fto', 'oit']}
                component={DepartmentUploads}
                path="/department-uploads"
              />

              {/*
                Error Routes
              */}

              <AuthenticatedRoute path="/forbidden" component={Forbidden} />

              {/*
                Forms Routes
              */}

              <AuthenticatedRoute component={FormContainer} path="/forms" />
              <AuthenticatedRoute component={PrintForms} path="/print-forms" />

              {/*
                Ftos Routes
              */}

              <AuthenticatedRoute component={ActiveFtos} path="/active-ftos" />

              {/*
                Manage Tags
              */}

              <AuthenticatedRoute
                allow={['depadmin']}
                component={TagsIndex}
                path="/tags"
              />

              {/*
                Manage Task Groups
              */}

              <AuthenticatedRoute
                allow={['depadmin']}
                component={TaskGroupContainer}
                path="/task-groups"
              />

              <AuthenticatedRoute
                allow={['depadmin', 'ftoc', 'fto', 'sup', 'cstaff', 'chief']}
                component={TestTemplateReportsIndex}
                path="/test-template-reports"
              />

              <AuthenticatedRoute
                allow={['depadmin', 'ftoc', 'fto', 'sup', 'cstaff', 'chief']}
                component={TestTemplatesIndex}
                path="/test-templates"
              />

              <AuthenticatedRoute
                allow={['depadmin', 'ftoc', 'oit', 'fto', 'sup', 'cstaff', 'chief']}
                component={TestsIndex}
                path="/tests"
              />

              <AuthenticatedRoute
                allow={['depadmin', 'ftoc', 'oit', 'fto', 'sup', 'cstaff', 'chief']}
                component={PersonalScheduleIndex}
                path="/personal-schedule"
              />

              <AuthenticatedRoute
                allow={['depadmin']}
                component={SubDepartments}
                path="/sub-departments"
              />


              <AuthenticatedRoute
                allow={['depadmin']}
                component={PackagerPage}
                path="/packager"
              />

              {/*
                Tasks training
              */}

              <AuthenticatedRoute
                allow={['sup', 'cstaff', 'ftoc', 'fto', 'oit', 'chief']}
                component={TaskTraining}
                path="/task-training"
              />

              {/*
                Oit analytics
              */}

              <AuthenticatedRoute
                component={OitAnalytics}
                path="/oit-analytics"
              />

              <AuthenticatedRoute
                component={FtoAnalytics}
                path="/fto-analytics"
              />

              {/*
                My Profile
              */}

              <AuthenticatedRoute
                component={MyProfileContainer}
                path="/my-profile"
              />

              {/*
                My Training Program
              */}

              <AuthenticatedRoute
                allow={['oit']}
                component={MyTrainingProgramDetail}
                path="/my-training-program"
              />

              <AuthenticatedRoute
                allow={['oit']}
                component={MyCompletedReports}
                path="/my-completed-reports"
              />

              {/*
                Reports Routes
              */}

              <AuthenticatedRoute component={ReportContainer} path="/reports" />

              <AuthenticatedRoute
                component={ScheduleReportsCalendar}
                path="/schedule-reports"
              />

              <AuthenticatedRoute
                component={ScheduleTestsCalendar}
                path="/schedule-tests"
              />

              {/*
                Trainees Routes
              */}

              <AuthenticatedRoute
                mine
                component={MyOitContainer}
                path="/my-oits"
              />

              <AuthenticatedRoute
                mine={false}
                component={OitContainer}
                path="/oits"
              />

              {/*
                Training Program Routes
              */}

              <AuthenticatedRoute
                component={TrainingProgramContainer}
                path="/training-programs"
              />

              {/*
                Users Routes
              */}

              <AuthenticatedRoute
                allow={['depadmin','ftoc']}
                component={UserContainer}
                path="/users"
              />

              <AuthenticatedRoute
                allow={['ftoc', 'sup', 'depadmin', 'chief', 'cstaff']}
                component={FtoCalendarPage}
                path="/fto-calendar"
              />

              {/*
                Fall-Through
              */}

              <Route component={NoMatch} />
            </Switch>
          </div>
          <Modal
            isOpen={this.state.isErrorModalOpen}
            toggle={this.closeErrorModal}
            className={this.props.className}
          >
            <ModalHeader toggle={this.closeErrorModal}>
              {this.apiErrorType}
            </ModalHeader>
            <ModalBody>
              <p>{this.apiErrorMessage}</p>
              <pre>
                <code>{this.apiErrorData}</code>
              </pre>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.closeErrorModal}>
                OK
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </Router>
    );
  }
}

// ----------------------
// Redux mapping
// ----------------------

const mapStateToProps = (state) => {
  return { apiErrors: state.common.apiErrors };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearApiError: () => {
      dispatch(commonActionCreators.clearApiError());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberApp);
